import { HighlightableButton } from '@monofe/ui-common';
import { IconMapMarker } from '@monofe/ui-common/icon';
import type { CSSProperties } from 'react';
import { useCallback } from 'react';
import type { ITextProps } from './interface';

const STYLING: CSSProperties = {
    position: 'absolute',
    cursor: 'pointer',
    width: '12vmin',
    height: '12vmin',
    marginTop: '-6vmin',
    marginLeft: '-6vmin',
};

export interface IMarkerItem {
    title: ITextProps;
    positionX: string;
    positionY: string;
    isVisible?: boolean;
    color?: string;
    style?: CSSProperties;
    onClick?: string | ((item: IMarkerItem) => void);
}

function useOnClick(props: IMarkerItem) {
    return useCallback(() => {
        if (typeof props.onClick === 'function') {
            props.onClick(props);
        }
    }, [props]);
}

function MarkerView(props: IMarkerItem): JSX.Element {
    const handleClick = useOnClick(props);
    const href = typeof props.onClick === 'string' ? props.onClick : undefined;

    return (
        <HighlightableButton
            description={props.title.text}
            isLink={Boolean(href)}
            onClick={typeof props.onClick === 'function' ? handleClick : undefined}
            href={href}
            style={{
                ...STYLING,
                top: props.positionY,
                left: props.positionX,
                opacity: props.isVisible ?? true ? 1 : 0,
                pointerEvents: props.isVisible ?? true ? 'auto' : 'none',
                ...props.style,
            }}
        >
            <IconMapMarker
                style={{
                    color: props.color ?? 'black',
                    width: '100%',
                    height: '100%',
                }}
            />
        </HighlightableButton>
    );
}

export default MarkerView;
